import React, { useState, useEffect } from "react";

const ToggleSwitch = ({ checked, onChange }) => (
  <div className={`toggle-switch ${checked ? "active" : ""}`} onClick={() => onChange(!checked)}>
    <div className="toggle-switch-slider"></div>
  </div>
);

const AccessibilitySettings = ({ settings, onUpdate }) => {
  const [localSettings, setLocalSettings] = useState(settings || {});

  useEffect(() => {
    setLocalSettings(settings || {});
  }, [settings]);

  const handleUpdate = async (key, value) => {
    const updated = { ...localSettings, [key]: value };
    setLocalSettings(updated);
    try {
      await onUpdate(updated);
    } catch (error) {
      setLocalSettings(localSettings);
    }
  };

  return (
    <div>
      <div className="settings-header">
        <h1>Acessibilidade</h1>
        <p>Ajuste a plataforma para suas necessidades</p>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">👁️ Recursos Visuais</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Leitor de tela</div>
            <div className="settings-item-description">
              Otimizar para uso com leitores de tela
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.screenReader === true}
              onChange={(val) => handleUpdate("screenReader", val)}
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Modo daltônico</div>
          </div>
          <div className="settings-item-control">
            <select
              className="settings-select"
              value={localSettings.colorBlindMode || "none"}
              onChange={(e) => handleUpdate("colorBlindMode", e.target.value)}
            >
              <option value="none">Desativado</option>
              <option value="protanopia">Protanopia</option>
              <option value="deuteranopia">Deuteranopia</option>
              <option value="tritanopia">Tritanopia</option>
            </select>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">⌨️ Navegação</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Navegação por teclado</div>
            <div className="settings-item-description">
              Melhorias para navegação usando apenas o teclado
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.keyboardNavigation === true}
              onChange={(val) => handleUpdate("keyboardNavigation", val)}
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Controle por voz</div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.voiceControl === true}
              onChange={(val) => handleUpdate("voiceControl", val)}
            />
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">🔊 Recursos de Áudio</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Texto para fala</div>
            <div className="settings-item-description">
              Ler textos em voz alta automaticamente
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.textToSpeech === true}
              onChange={(val) => handleUpdate("textToSpeech", val)}
            />
          </div>
        </div>
      </div>

      <div className="settings-info-card">
        <div className="settings-info-card-title">💡 Recursos de Acessibilidade</div>
        <div className="settings-info-card-text">
          Estamos comprometidos em tornar nossa plataforma acessível para todos.
          Se você tiver sugestões de melhorias, entre em contato conosco.
        </div>
      </div>
    </div>
  );
};

export default AccessibilitySettings;
